<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <a href="/">
          <v-img
            v-if="includeTextLogo()"
            :src="require(`../assets/${getName()}-text.png`)"
            class="mt-2"
            contain
            height="125"
            style="cursor: pointer; padding-bottom: 5px"
          />
          <v-img
            v-else
            :src="require(`../assets/${getName()}.png`)"
            class="mt-2"
            contain
            height="100"
            style="cursor: pointer"
          />
        </a>
      </v-col>
      <v-col style="padding-top: 0px; padding-bottom: 0px">
        <v-btn
          v-if="!includeTextLogo()"
          text
          x-large
          color="black"
          style="pointer-events: none"
          >{{ getTitle() }}</v-btn
        >
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 15px;
          "
        >
          <div class="text-body-2" v-if="phoneNumbers.length > 0">
            <a
              :href="'tel:' + phoneNumbers[0]"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                text-decoration: none;
              "
            >
              <v-icon>mdi-phone</v-icon>
              <span>Call</span>
            </a>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
            "
            class="text-body-2"
            v-if="viberNumbers.length > 0"
          >
            <a
              :href="`viber://add?number=${viberNumbers[0]}`"
              style="
                text-decoration: none;
                display: flex;
                align-items: center;
                gap: 6px;
              "
            >
              <img style="width: 22px" src="/viber.svg" />
              <span>Chat</span>
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Header",
  computed: {
    phoneNumbers() {
      return [
        this.getConfigValue("Contact phone number 1"),
        this.getConfigValue("Contact phone number 2"),
      ].filter(Boolean);
    },
    viberNumbers() {
      return [
        this.addPrefix(this.getConfigValue("Contact Viber number 1")),
        this.addPrefix(this.getConfigValue("Contact Viber number 2")),
      ].filter(Boolean);
    },
  },
  methods: {
    addPrefix(num) {
      if (!num) return num;
      return num.startsWith("960") ? num : "960" + num;
    },
    getConfigValue(name) {
      const configs = this.$store?.getters?.getConfigs ?? [];
      const config = configs.find((c) => c.name === name);
      return (config?.value ?? "").trim();
    },
    includeTextLogo() {
      return process.env.VUE_APP_TEXT_LOGO === "true" ? true : false;
    },
    getName() {
      return process.env.VUE_APP_NAME ?? "bmt";
    },
    getTitle() {
      return process.env.VUE_APP_TITLE ?? "Book My Transfer";
    },
  },
};
</script>
